import { defineComponent as _defineComponent } from 'vue'
import usePublicPageBackgrounds from '@/mixins/usePublicPageBackgrounds';
import LPBgImage from '@/views/public/landingpage/components/LPBgImage.vue';
import RoleSelector from '@/views/public/components/RoleSelector.vue';

import BGLogoDesktop from '@/assets/img/landingpage-switch/Frame Logo Desktop.webp';
import BGLogoTablet from '@/assets/img/landingpage-switch/Frame Logo Tablet.webp';
import BGLogoSmartphone from '@/assets/img/landingpage-switch/Frame Logo Smartphone.webp';
import BGPeopleDesktop from '@/assets/img/landingpage-switch/Frame People Desktop.webp';
import BGPeopleTablet from '@/assets/img/landingpage-switch/Frame People Tablet.webp';
import BGPeopleSmartphone from '@/assets/img/landingpage-switch/Frame People Smartphone.webp';

import { computed } from 'vue';
import { computedEager, useMediaQuery } from '@vueuse/core';
import LPBgArrow from '../landingpage/components/LPBgArrow.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicBlogPage',
  props: {
    pageType: { default: 'overview' }
  },
  setup(__props: any) {



const bgsLogo: [string, string, string] = [BGLogoDesktop, BGLogoTablet, BGLogoSmartphone];
const { getResponsiveImage } = usePublicPageBackgrounds();
const bgLogo = getResponsiveImage(bgsLogo);

const bgsPeople = [BGPeopleDesktop, BGPeopleTablet, BGPeopleSmartphone];
const isSmartphone = useMediaQuery('(width < 800px)');
const isTablet = useMediaQuery('(800px <= width < 1020px)');

const backgroundNr = computedEager(() => {
  if (isSmartphone.value) return 2;
  if (isTablet.value) return 1;
  return 0;
});

const bgPeople = computed(() => bgsPeople[backgroundNr.value]);

return { __sfc: true,bgsLogo, getResponsiveImage, bgLogo, bgsPeople, isSmartphone, isTablet, backgroundNr, bgPeople, LPBgImage, RoleSelector, LPBgArrow }
}

})